import { ConditionCardItem } from "../../../views/UIelems/v2/conditionsCards/ConditionCardItem";

export const IconTile = ({ tiles, width }) => {

	return (
		<div className="flex flex-wrap justify-between w-full">
			{tiles.map(tile => (
				<div key={`${tile.title}`} className={`justify-center ${width || "w-1/2 md:w-1/5 min-w-[101px]"}`}>
					<ConditionCardItem {...tile} isIcon={true}/>
				</div>
			))}
		</div>
	);
};
